import { List } from "@chakra-ui/react";
import { useMemo } from "react";
import * as BoundaryService from "src/components/Boundary/services";
import { GenericError } from "src/components/Feedback/GenericError";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import * as GQL from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { FormSchoolRankWithAdmissions } from "../../../admissions";
import * as RankedSchoolListItem from "./RankedSchoolListItem";

export type Form = RankedSchoolListItem.Form;
export type School =
  BoundaryService.WithBoundaryTags<RankedSchoolListItem.School>;
export type Offer = RankedSchoolListItem.Offer;
export type Waitlist = RankedSchoolListItem.Waitlist;
interface RankedSchoolListProps {
  formTemplateId: uuid;
  form: Form;
  formSchoolRanks: FormSchoolRankWithAdmissions[];
  gradeLabel: string;
  studentName: string;
  rankingEnabled: boolean;
  enrollmentPeriodKey: string | null;
  showWaitlistPosition: boolean;
}

export function RankedSchoolList(props: RankedSchoolListProps) {
  const { form, formSchoolRanks, rankingEnabled } = props;

  const acceptedOfferSchoolName = formSchoolRanks.find(
    (schoolRank) =>
      schoolRank.offers[0]?.status === GQL.offer_status_enum.Accepted
  )?.school?.name;

  const { withBoundaryTags } = BoundaryService.useBoundaryTags<School>({
    formId: form.id,
  });

  const rankedSchoolsWithBoundaryTagsRemoteData = useMemo(() => {
    return RD.combine(
      formSchoolRanks.map((rankedSchool) => {
        const schoolWithBoundaryTags = withBoundaryTags(rankedSchool.school);

        return schoolWithBoundaryTags.map((school) => {
          return {
            ...rankedSchool,
            school,
          };
        });
      })
    );
  }, [formSchoolRanks, withBoundaryTags]);

  return (
    <List
      display="flex"
      flexDirection="column"
      fontSize="sm"
      gap={4}
      styleType={rankingEnabled ? "none" : "disc"}
      ml={0}
      mt={4}
    >
      <RemoteDataView
        error={(error) => <GenericError error={error} />}
        remoteData={rankedSchoolsWithBoundaryTagsRemoteData}
      >
        {(rankedSchools) => (
          <>
            {rankedSchools.map((schoolRank) => (
              <RankedSchoolListItem.RankedSchoolListItem
                acceptedOfferSchoolName={acceptedOfferSchoolName}
                offer={schoolRank.offers[0] ?? null}
                formSchoolRank={schoolRank}
                waitlist={schoolRank.waitlists[0] ?? null}
                key={schoolRank.rank}
                school={schoolRank.school}
                {...props}
              />
            ))}
          </>
        )}
      </RemoteDataView>
    </List>
  );
}
